var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.378 5.85541C11.388 5.76374 10.515 6.50626 10.425 7.52379L10.2 10.173H12.738V12.0064H10.038L9.642 16.6541C9.57464 17.4197 9.2728 18.1444 8.77913 18.7258C8.28546 19.3073 7.62491 19.716 6.8908 19.8943C6.15669 20.0727 5.38612 20.0115 4.68796 19.7196C3.98981 19.4277 3.39935 18.9197 3 18.2674L4.35 16.8924C4.647 17.8549 5.664 18.3958 6.6 18.0841C7.302 17.8641 7.797 17.2316 7.86 16.4891L8.238 12.0064H5.538V10.173H8.4L8.643 7.35879C8.72544 6.38926 9.18196 5.49258 9.91248 4.86536C10.643 4.23814 11.5879 3.93157 12.54 4.01286C13.674 4.11369 14.7 4.75538 15.294 5.74541L13.944 7.12045C13.719 6.41459 13.107 5.91958 12.378 5.85541ZM21 13.519L19.731 12.2264L17.184 14.8207L14.637 12.2264L13.35 13.519L15.915 16.1316L13.35 18.7075L14.637 20L17.184 17.4058L19.731 20L21 18.7075L18.453 16.1316L21 13.519Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.6aaa04a5.svg";
export { ForwardRef as ReactComponent };